import React from "react";
import { View } from "react-native";
export const BackgroundOnlyImage = ({ backgroundColor, dimensions }) => {
    return React.createElement(View, { style: {
            backgroundColor: backgroundColor,
            width: dimensions.width,
            height: dimensions.height,
        } });
};
//# sourceMappingURL=BackgroundOnlyImage.js.map